<template>
    <div></div>
</template>

<script>
import { mapState } from 'vuex'

import BookReadingService from '@/services/bookReading'

export default {
    computed: {
        ...mapState({
            bookReadConf: (state) => state.bookReading.bookReadConf,
            fontFamily: (state) => state.bookReading.bookReadConf.fontFamily,
            fontSize: (state) => state.bookReading.bookReadConf.fontSize,
            sound: (state) => state.bookReading.bookReadConf.sound,
            soundActive: (state) => state.bookReading.bookReadConf.soundActive,
            showNotes: (state) => state.bookReading.bookReadConf.showNotes,
            book: (state) => state.bookReading.book,
            user: (state) => state.userData.user,
        }),
    },
    watch: {
        sound() {
            this.saveConfigs()
        },
        fontFamily() {
            this.saveConfigs()
        },
        fontSize() {
            this.saveConfigs()
        },
        soundActive() {
            this.saveConfigs()
        },
        showNotes() {
            this.saveConfigs()
        },
    },
    methods: {
        saveConfigs() {
            BookReadingService.updateBookReadConfig({
                userId: this.user.id,
                bookId: this.book.id,
                typography: this.bookReadConf.typography,
                pageTexture: this.bookReadConf.pageTexture,
                fontColor: this.bookReadConf.fontColor,
                fontSize: this.bookReadConf.fontSize,
                fontFamily: this.bookReadConf.fontFamily,
                soundActive: this.bookReadConf.soundActive,
                sound: this.bookReadConf.sound,
                showNotes: this.bookReadConf.showNotes,
            }).catch((error) => console.error(error))
        },
    },
}
</script>
